export default "__VITE_ASSET__CugXfqFn__"